import React from 'react';
import { AVERAGE_SEO_SCORE_OF_TOP_100_WEBSITES } from '../../../settings/config';

type Props = {
    seoScore: number;
    issues: number;
};

export default function SeoScoreDescription({ seoScore, issues }: Props) {
    return (
        <span className="description">
            {seoScore < 50 && (
                <>
                    Unfortunately, this webpage received an SEO score of <strong>{seoScore} out of 100</strong>, which is significantly lower than the average
                    score of <strong>{AVERAGE_SEO_SCORE_OF_TOP_100_WEBSITES}</strong>. Our analysis has identified <strong>{issues} important issues</strong>{' '}
                    that need to be addressed urgently to improve your website's performance and avoid further damage to your search engine visibility.
                </>
            )}

            {seoScore >= 50 && seoScore < AVERAGE_SEO_SCORE_OF_TOP_100_WEBSITES && (
                <>
                    This webpage received an SEO score of <strong>{seoScore} out of 100</strong>, which is below the average score of{' '}
                    <strong>{AVERAGE_SEO_SCORE_OF_TOP_100_WEBSITES}</strong>. However, there are <strong>{issues} important issues</strong> that need to be
                    fixed to improve your website's ranking on search engines and enhance its overall performance.
                </>
            )}

            {seoScore === AVERAGE_SEO_SCORE_OF_TOP_100_WEBSITES && (
                <>
                    This webpage received an SEO score of <strong>{seoScore} out of 100</strong>, which is the same as the average score of{' '}
                    <strong>{AVERAGE_SEO_SCORE_OF_TOP_100_WEBSITES}</strong>. Our analysis has identified <strong>{issues} important issues</strong> that can be
                    addressed to further enhance your website's performance and improve its search engine visibility.
                </>
            )}

            {seoScore > AVERAGE_SEO_SCORE_OF_TOP_100_WEBSITES && (
                <>
                    This webpage received an SEO score of <strong>{seoScore} out of 100</strong>, which is higher than the average score of{' '}
                    <strong>{AVERAGE_SEO_SCORE_OF_TOP_100_WEBSITES}</strong>. Our analysis has identified <strong>{issues} important issues</strong> that can be
                    addressed to further enhance your website's performance and improve its search engine visibility.
                </>
            )}
        </span>
    );
}
